import { createContext, useContext } from 'react';

import useStickyState from './useStickyState';

export const PopupContext = createContext(null);

const PopupProvider = (props: any) => {
  const [ sideNavOpen, setSideNavOpen ] = useStickyState(false, 'sideNavOpen');

	const onPopupClose = (action?: () => void) => {
		document.body.classList.remove('popupOpen');
		action && action();
	}

	const onPopupOpen = (action?: () => void) => {
		document.body.classList.add('popupOpen');
		action && action();
	}

	const toggleSideNav = () => {
		if (sideNavOpen) {
			onPopupClose();
		} else {
			onPopupOpen();
		}

		setSideNavOpen((currentValue: boolean) => !currentValue);
	}

  return <PopupContext.Provider value={{
		onPopupClose,
		onPopupOpen,
		sideNavOpen,
		toggleSideNav
	}} {...props} />;
};

export const usePopupContext = (): any => useContext(PopupContext);

export default PopupProvider;


